// @ts-nocheck
const initialState = {
  pages: {
    oneOnOneChatWindow: {
      heading: {
        background: "linear-gradient(to bottom right, rgb(39, 39, 45), rgb(43, 44, 52))"
      }
    }
  }
};

const stylingThemeReducer = (state = initialState, action) => {
  switch (action?.type) {

    default: {
      return state;
    }
  }
};

export default stylingThemeReducer;
export {
  initialState
}